if (typeof window.intercomSettings === "undefined") {
    window.intercomSettings = {};
}

(function () {
    let ic = window.Intercom;
    if (typeof ic === "function") {
        ic('reattach_activator');
        ic('update', intercomSettings);
    } else {
        let i = function () {
            i.c(arguments)
        };
        i.q = [];
        i.c = function (args) {
            i.q.push(args)
        };
        window.Intercom = i;

        function l() {
            let s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://widget.intercom.io/widget/' + window.intercomSettings.app_id ;
            let x = document.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
        }

        if (window.attachEvent) {
            window.attachEvent('onload', l);
        } else {
            window.addEventListener('load', l, false);
        }
    }
})();


(function() {
    const intercomHideClass = "intercom--hide",
    bodyEl = document.querySelector('body')

    const intercomTrigger = bodyEl.querySelectorAll(".btn-intercom, .intercom-sidebar, [data-intercom-trigger]")

    // Open/close Intercom, force it will be visible if opened
    intercomTrigger.forEach((element) => {
        element.addEventListener('click', () => {
            if (typeof Intercom === "undefined") {
                return false;
            }

            const intercomFrame = document.querySelectorAll(".intercom-messenger-frame")

            const opened = intercomFrame.length === 1;

            if (!opened || bodyEl.classList.contains(intercomHideClass)) {
                bodyEl.classList.remove(intercomHideClass);
                Intercom("show");
            } else {
                Intercom("hide");
            }
        })
    })

    // Open Intercom and force its visibility if requested by URL
    if ((new URL(window.location)).searchParams.get("support") === "open") {
        bodyEl.classList.remove(intercomHideClass);
        Intercom("show");
    }
})();
